import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';

export default function About() {
  return (
    <div className="static-page">
      <div className="static-page__hero">
        <h1>About MK Classes</h1>
        <p>Connecting students with expert teachers for personalised 1-on-1 learning.</p>
      </div>

      <div className="static-page__body">
        <section className="static-section">
          <h2>Our Mission</h2>
          <p>
            MK Classes was built with one goal: make quality education accessible to every student.
            Whether you're preparing for NEET, JEE, board exams, or simply want to understand
            Chemistry and Biology at a deeper level, we connect you with verified expert teachers
            who will guide you every step of the way.
          </p>
        </section>

        <section className="static-section">
          <h2>What We Offer</h2>
          <div className="static-cards">
            {[
              { icon: 'note', title: 'Notes & Videos', desc: 'Clear notes, blogs and video lessons for every topic, all in the Study Hub.' },
              { icon: 'query', title: 'Doubt Solving', desc: 'Ask your questions in the Queries section and get answers from MK Classes teachers.' },
              { icon: 'group', title: 'Live Classes', desc: 'Book a personal 1-on-1 session or join a live group meeting.' },
              { icon: 'target', title: 'Goal-Oriented', desc: 'Whether it\'s NEET, JEE or board exams, our teachers know exactly what you need.' },
            ].map(c => (
              <div key={c.title} className="static-card">
                <span className="icon-badge"><Icon name={c.icon} size={22} /></span>
                <h4>{c.title}</h4>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="static-section">
          <h2>Why Students Choose Us</h2>
          <ul className="static-list">
            <li>Experienced MK Classes teachers</li>
            <li>Notes, blogs, updates and videos in one place</li>
            <li>Ask doubts anytime and get clear answers</li>
            <li>Personal sessions and live group meetings</li>
          </ul>
        </section>

        <section className="static-section static-section--cta">
          <h2>Ready to start learning?</h2>
          <p>Join thousands of students already learning on MK Classes.</p>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1.25rem', flexWrap: 'wrap' }}>
            <Link to="/hub" className="btn-cta-primary">Open Study Hub</Link>
            <Link to="/register" className="btn-cta-outline-dark">Create Free Account</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
